<template>
  <div>
    <Card class="p-shadow-1">
        <template #title>
            Finalizar
        </template>
        <template #content>
          <Message severity="success">
            <p class="p-text-bold">Sucesso</p>
          </Message>
        </template>
        <template #footer>
            <div class="p-grid p-nogutter p-jc-start">
                <Button label="Fechar" @click="finalizar" icon="pi pi-checked" />                
            </div>            
        </template>
    </Card>      
  </div>
</template>

<script>
export default {
  methods: {
    finalizar() {
      this.$router.push('/cadastros/funcionarios');
    }
  }
}
</script>

<style>

</style>